import type { Ref } from "vue";
import { createEventHook, useEventListener } from "@vueuse/core";

export function useIframeListener<T>(iframe: Ref<HTMLIFrameElement | undefined | null>) {
  const message = createEventHook<T>();

  useEventListener("message", event => {
    const iframeEl = iframe.value;
    if (!iframeEl || !iframeEl.contentWindow || iframeEl.contentWindow !== event.source) {
      return;
    }

    let { data } = event;
    if (typeof data === "string") {
      try {
        data = JSON.parse(event.data) as T;
      } catch {
        return;
      }
    }
    if (!data.key) return;

    // @ts-expect-error there's an issue with the typings,
    // https://github.com/vueuse/vueuse/issues/4610
    message.trigger(data);
  });

  return {
    message,
  };
}
